<div class="component" (input)="onInput()">
  <ng-container *ngTemplateOutlet="inventoryTab"></ng-container>
  <ng-container *ngTemplateOutlet="inventoryViewSetting"></ng-container>
  <div *ngIf="getGameObjects(selectTab).length < 1">{{getTabTitle(selectTab)}}インベントリは空です</div>
  <div (contextmenu)="onContextMenu($event, gameObject)" *ngFor="let gameObject of getGameObjects(selectTab); trackBy: trackByGameObject"
    (click)="selectGameObject(gameObject)" (dblclick)="focusGameObject(gameObject, $event)" [ngClass]="{'box': true, 'selected': (selectedIdentifier === gameObject.identifier)}">
    <ng-container *ngTemplateOutlet="gameObjectTags; context:{ gameObject: gameObject}"></ng-container>
  </div>
  <div *ngIf="selectTab === 'graveyard'" style="padding-top: 6px;">
    <button class="danger" (click)="cleanInventory()" [attr.disabled]="getGameObjects(selectTab).length < 1 ? '' : null">墓場を空にする</button>
  </div>
</div>
<ng-template #inventoryTab>
  <form class="is-sticky-top">
    <div class="tab">
      <label *ngFor="let inventoryType of inventoryTypes">
        <input name="tab" type="radio" value="{{inventoryType}}" ng-control="options" [(ngModel)]="selectTab">
        <div>{{getTabTitle(inventoryType)}} ({{ getGameObjects(inventoryType).length }})</div>
      </label>
    </div>
  </form>
</ng-template>
<ng-template #inventoryViewSetting>
  <ng-container *ngIf="isEdit">
    <div>
      <div style="font-size: 12px;"><b>並び順: </b></div>
      <input [(ngModel)]="sortTag" placeholder="タグ名" class="order-control" />
      <select [(ngModel)]="sortOrder" class="order-control">
        <option value="ASC">昇順</option>
        <option value="DESC">降順</option>
      </select>
    </div>
    <div style="font-size: 12px; padding-top: 6px;"><b>表示項目: </b></div>
    <input style="width: 100%; box-sizing: border-box;" [(ngModel)]="dataTag" placeholder="スペース区切りでタグ名 スラッシュで改行 ex.「HP MP / メモ」" />
    <div style="padding-top: 6px;">
      <button class="tab-setting small-font" (click)="toggleEdit()"><i class="material-icons small-font">settings</i>完了</button>
    </div>
  </ng-container>
  <ng-container *ngIf="!isEdit">
    <table style="font-size: 0.8em;">
      <tr>
        <th style=" vertical-align:middle;" nowrap>並び順:</th>
        <td style=" vertical-align:middle;" nowrap>
          <ng-container *ngIf="0 < sortTag.length">{{sortTag}} ({{sortOrderName}})</ng-container>
          <ng-container *ngIf="sortTag.length < 1">-</ng-container>
        </td>
        <td width="100%" nowrap>
          <button class="tab-setting small-font" (click)="toggleEdit()"><i class="material-icons small-font">settings</i>設定</button>
          <label *ngIf="selectTab === 'table'" style="float: right; font-size: smaller"><input type="checkbox" [(ngModel)]="indicateAll" /><b>すべて表示<sup class="self_only">*</sup></b></label>
        </td>
      </tr>
    </table>
  </ng-container>
</ng-template>
<ng-template #gameObjectTags let-gameObject="gameObject">
  <div class="inventory-object">
    <div class="object-name">
      <button class="indicate" [disabled]="selectedIdentifier !== gameObject.identifier" style="font-size: 0.8em; padding: 1px; width: 24px; height: 16px; margin-bottom: 1px" title="オーバービューに顔アイコンを使用" [ngClass]="{'is-active': gameObject.isUseIconToOverviewImage}" (click)="gameObject.isUseIconToOverviewImage = !gameObject.isUseIconToOverviewImage">
        <i *ngIf="gameObject.faceIcon && 0 < gameObject.faceIcon?.url.length; else altImage" class="face-icon"><img [src]="gameObject.faceIcon.url | safe: 'resourceUrl'" alt=""></i>
        <ng-template #altImage>
          <i class="material-icons" style="font-size: 1em;">emoji_emotions</i>
        </ng-template>
      </button>
      {{gameObject.name}}
      <button class="indicate" [disabled]="selectedIdentifier !== gameObject.identifier" style="font-size: 0.8em; padding: 2px 5px;" title="💭の表示" [ngClass]="{'is-active': gameObject.isShowChatBubble}" (click)="gameObject.isShowChatBubble = !gameObject.isShowChatBubble">
        <i class="material-icons" style="font-size: 1em;">{{ gameObject.isShowChatBubble ? 'textsms' : 'speaker_notes_off'}}</i>
      </button>
      <button class="indicate" [disabled]="selectedIdentifier !== gameObject.identifier" style="font-size: 0.8em; padding: 1px; width: 24px; height: 16px; margin-bottom: 1px" title="影の表示" [ngClass]="{'is-active': gameObject.isDropShadow}" (click)="gameObject.isDropShadow = !gameObject.isDropShadow">
        <i *ngIf="gameObject.shadowImageFile && 0 < gameObject.shadowImageFile.url.length; else altShadow" class="face-icon"><img style="filter: brightness(0);" [ngStyle]="{'opacity': gameObject.isDropShadow ? 0.7 : 0.3}" [src]="gameObject.shadowImageFile.url | safe: 'resourceUrl'" alt=""></i>
        <ng-template #altShadow>
          <i class="material-icons" style="font-size: 1em;">{{ gameObject.isDropShadow ? 'star_half' : 'star_border'}}</i>
        </ng-template>      
      </button>
      <button class="indicate" [disabled]="selectedIdentifier !== gameObject.identifier" style="font-size: 0.8em; padding: 2px 5px;" title="他のキャラクターに乗る" [ngClass]="{'is-active': !gameObject.isNotRide}" (click)="gameObject.isNotRide = !gameObject.isNotRide">
        <i class="material-icons" style="font-size: 1em;">{{ !gameObject.isNotRide ? 'directions_bike' : 'directions_run'}}</i>
      </button>
      <button class="indicate" [disabled]="selectedIdentifier !== gameObject.identifier" style="font-size: 0.8em; padding: 2px 5px;" title="高度の表示" [ngClass]="{'is-active': gameObject.isAltitudeIndicate}" (click)="gameObject.isAltitudeIndicate = !gameObject.isAltitudeIndicate">
        <i class="material-icons rotate" style="font-size: 1em;">straighten</i><span style="display: inline-block; text-align: center; font-size: xx-small; color: gray; min-width: 2em;">{{ gameObject.altitude }}</span>
      </button>
      <button class="indicate" [disabled]="selectedIdentifier !== gameObject.identifier" style="font-size: 0.8em; padding: 2px 5px;" title="テーブルインベントリに表示" [ngClass]="{'is-active': gameObject.isInventoryIndicate}" (click)="gameObject.isInventoryIndicate = !gameObject.isInventoryIndicate">
        <i class="material-icons" style="font-size: 1em;">all_inbox</i>
      </button>
      <button *ngIf="selectedIdentifier === gameObject.identifier" style="font-size: 0.8em; padding: 2px 5px;" title="メニュー" (click)="onContextMenu($event, gameObject)">
        <i class="material-icons" style="font-size: 1em;">settings</i>
      </button>
    </div>
    <div class="object-tags-box">
      <div class="table-cell image-box">
        <span class="aura" [ngClass]="{black: gameObject.aura == 0, blue: gameObject.aura == 1, green: gameObject.aura == 2, cyan: gameObject.aura == 3, red: gameObject.aura == 4, magenta: gameObject.aura == 5, yellow: gameObject.aura == 6, white: gameObject.aura == 7}">
          <img *ngIf="gameObject.imageFile.url" class="inverser" [src]="gameObject.imageFile.url | safe: 'resourceUrl'" [ngClass]="{inverse: gameObject.isInverse, hollow: gameObject.isHollow, 'black-paint': gameObject.isBlackPaint}" />
        </span>
      </div>
      <div class="table-cell">
        <div *ngIf="gameObject.rootDataElement">
          <ng-container *ngFor="let dataElm of getInventoryTags(gameObject); trackBy: trackByGameObject">
            <ng-container *ngTemplateOutlet="dataElmTag; context:{ dataElm: dataElm, name: gameObject.name }"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #dataElmTag let-dataElm="dataElm" let-name="name">
  <ng-container *ngIf="dataElm?.name === newLineString"><br></ng-container>
  <div *ngIf="dataElm && dataElm.name !== newLineString" class="object-tag">
    <ng-container [ngSwitch]="dataElm.attributes['type']">
      <ng-container *ngSwitchCase="'simpleNumber'">
        <div class="tag-name">{{dataElm.name}}</div>
        <div style="text-align: center;">
          <div style="display: inline-block;">
            <div class="tag-value-box">
              <div class="hidden-spacer" style="font-weight: bold;">{{dataElm.value}}</div>
              <input appLogging [logging.name]="name" [logging.dataElement]="dataElm" class="input tag-value" type="{{(dataElm.value && dataElm.value == +dataElm.value) ? 'number' : 'text'}}" size="1" [(ngModel)]="dataElm.value" placeholder="" />
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'numberResource'">
        <div class="resource-tag">
          <div style="font-size: 0.8em; display: inline-block; margin-right: 0.5em;">{{dataElm.name}}</div>
          <input appLogging [logging.name]="name" [logging.dataElement]="dataElm" class="input resource-value" type="number" size="1" [(ngModel)]="dataElm.currentValue" placeholder="Value" attr.data-init-value="{{ dataElm.currentValue }}" />
        </div>
        <div class="resource-tag">
          <input appLogging [logging.name]="name" [logging.dataElement]="dataElm" type="range" title="{{dataElm.currentValue}}" [style]="'font-size: 0.8em; min-width: 1em; width:' + (dataElm.name.length + 4.5) + 'em; --min: 0; --max: ' + dataElm.value + '; --val:' + dataElm.currentValue +';' | safe: 'style'"
            min="0" max="{{!+dataElm.value ? 1000 : dataElm.value}}" [ngStyle]="{'background-color':'green'}" [(ngModel)]="dataElm.currentValue" attr.data-init-value="{{ dataElm.currentValue }}" />
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'checkProperty'">
        <div class="tag-name" [style.textDecoration]="dataElm.value ? 'none' : 'line-through'">{{dataElm.name}}</div>
        <div style="text-align: center;">
          <div style="display: inline-block;">
            <div class="tag-value-box">
              <input appLogging [logging.name]="name" [logging.dataElement]="dataElm" type="checkbox" [(ngModel)]="dataElm.value" checked="{{dataElm.value ? 'checked' : ''}}" (change)="dataElm.value = (dataElm.value ? dataElm.name : '')">
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'abilityScore'">
        <div class="tag-name">{{dataElm.name}}</div>
        <div style="text-align: center;">
          <div style="display: inline-block;">
            <div class="tag-value-box">
              <div class="hidden-spacer" style="font-weight: bold;">{{dataElm.value}}</div>
              <input appLogging [logging.name]="name" [logging.dataElement]="dataElm" class="input tag-value" type="{{(dataElm.value && dataElm.value == +dataElm.value) ? 'number' : 'text'}}" size="1" [(ngModel)]="dataElm.value" placeholder="" />
              <span *ngIf="dataElm.currentValue" style="font-size: smaller;">({{ (dataElm.calcAbilityScore() >= 0 ? '+' : '') + dataElm.calcAbilityScore() }})</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'url'">
        <div class="tag-name"><a [attr.title]="dataElm.value" [ngClass]="{'outer-link': !stringUtil.sameOrigin(dataElm.value)}" target="_blank" [attr.href]="(stringUtil.validUrl(dataElm.value) ? dataElm.value : '') | safe: 'url'" [attr.disabled]="!stringUtil.validUrl(dataElm.value) ? '' : null"
          (click)="stringUtil.validUrl(dataElm.value) ? openUrl(dataElm.value, name, dataElm.name) : false">{{dataElm.name}}</a></div>
      </ng-container>
      <ng-container *ngSwitchCase="'colors'"></ng-container>
      <ng-container *ngSwitchCase="'color'"></ng-container>
      <ng-container *ngSwitchCase="'note'"></ng-container>
      <ng-container *ngSwitchDefault>
        <ng-container *ngIf="0 == dataElm.children.length">
          <div class="tag-name">{{dataElm.name}}</div>
          <div style="text-align: center;">
            <div style="display: inline-block;">
              <div class="tag-value-box">
                <div class="hidden-spacer" style="font-weight: bold;">{{dataElm.value}}</div>
                <input class="input tag-value" style="min-width: 4em" type="{{dataElm.name === 'size' || dataElm.name === 'altitude' ? 'number' : 'text'}}" min="{{dataElm.name === 'size' ? '0' : ''}}" size="1" [(ngModel)]="dataElm.value" />
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
